<template>
    <div class="ordersubmit">
        <header-component></header-component>
        <div class="container-fluid g-my-100">
          <div
            class="g-bg-img-hero g-bg-pos-top-center g-pos-rel g-z-index-0 g-mt-minus-150"
            style="background-image: url(/static/assets/include/svg/svg-bg4.svg)"
          >
            <div class="row">
                <div class="col-lg-8 offset-lg-2">
                    <div class="row center">
                        <order-special v-if="orderType =='special'"></order-special>
                        <order-pending v-else-if="orderType == 'pending'" ></order-pending>
                        <page-loader v-else-if="orderDetailsLoading && orderType =='error'"></page-loader>
                        <order-error v-else @clicked="ToggleHelpForm()" :Account="Account" :orderDetails="orderDetails"></order-error>
                        <div v-if="orderType != 'error'" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <button  @click="Route('OrderTracking')" class="btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-px-30 g-mx-10 g-my-10">Track Order</button>
                            <button @click="Route('Order')" class="btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-px-30 g-mx-10 g-my-10">Place New Order</button>
                          <br/><br/><br/><br/>
                        </div>
                        <div v-else class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <button  @click="EditOrder($route.params.code)" class="btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-px-30 g-mx-10 g-my-10">Edit Order</button>
                            <button @click="Route('Order')" class="btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-px-30 g-mx-10 g-my-10">Place New Order</button>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
        <footer-component></footer-component>
    </div>
</template>
<script>
    import HeaderComponent from "@/components/shared/HeaderComponent";
    import FooterComponent from "@/components/shared/FooterComponent";
    import HelpForm from "@/components/shared/HelpForm";
    import OrderSpecial from "@/components/portal/Order/OrderSubmit/OrderSubmitComponent/OrderSpecial";
    import OrderPending from "@/components/portal/Order/OrderSubmit/OrderSubmitComponent/OrderPending";
    import OrderError from "@/components/portal/Order/OrderSubmit/OrderSubmitComponent/OrderError";
    import PageLoader from "@/components/shared/PageLoader";
    export default {
        components: {HeaderComponent, HelpForm, FooterComponent, OrderSpecial, OrderPending, OrderError, PageLoader},
        data(){
            return{
                orderType:null,
                orderDetails:null,
                orderDetailsLoading:false,
                showHelpForm:false,
                Account:null
            }
        },
        methods: {
            Route(value){
                this.$router.push({name: value});
            },
            GetOrderType(){
                if(this.$route.params.type == '0'){
                    this.orderType = 'pending';
                }else if(this.$route.params.type == '1'){
                    this.orderType = 'special';
                }else{
                    this.orderType = 'error';
                    this.GetOrderDetails();
                }
            },
            GetOrderDetails(){
                var _this = this;
                this.orderDetailsLoading = true;
                axios.get('/Order/Get/' + this.$route.params.code, {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                    .then(function (response) {
                            _this.orderDetails = response.data.raw;
                            _this.Account = response.data.raw.accountDetails;
                            _this.orderDetailsLoading = false;
                    })
                    .catch(function (error) {
                            console.log(error);
                    });
            },
            EditOrder(id){
                this.$router.push({name: 'Order',  params: {code:id, EditOrReuse: 0}});
            },
            ToggleHelpForm(){
                this.showHelpForm = !this.showHelpForm;
            },
            CloseModal(){
                this.showHelpForm = false;
                document.body.classList.remove("body-overflow");
            }
        },
        created(){
            this.GetOrderType();

        }
    }
</script>



// WEBPACK FOOTER //
// OrderSubmit.vue?36cae8f4